<div class="loader-overlay" [ngClass]="{ 'show': isLoading }">
  <div class="loader-content" [ngClass]="{'appear-as-modal': appearAsModal}">
    <!-- <span class="loader-text">Loading...</span> -->

    <!--if loader type is spinner we will show cds-progress spinner-->
    @if (loaderType === 'SPINNER') {
      <div>
        <cds-progress mode="indeterminate" type="ring" [diameter]="diameter"></cds-progress>
      </div>
    }

    <!--loader text-->
    @if (loaderText) {
      <div class="loader-content__text">
        {{ loaderText }}
      </div>
    }
  </div>
</div>